/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectDomain
 */
export interface ProjectDomain {
    /**
     * 
     * @type {string}
     * @memberof ProjectDomain
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomain
     */
    project?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomain
     */
    hostName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomain
     */
    faviconUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDomain
     */
    isBuiltin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDomain
     */
    isEnabled?: boolean;
}

/**
 * Check if a given object implements the ProjectDomain interface.
 */
export function instanceOfProjectDomain(value: object): value is ProjectDomain {
    return true;
}

export function ProjectDomainFromJSON(json: any): ProjectDomain {
    return ProjectDomainFromJSONTyped(json, false);
}

export function ProjectDomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDomain {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'project': json['project'] == null ? undefined : json['project'],
        'hostName': json['hostName'] == null ? undefined : json['hostName'],
        'faviconUrl': json['faviconUrl'] == null ? undefined : json['faviconUrl'],
        'isBuiltin': json['isBuiltin'] == null ? undefined : json['isBuiltin'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
    };
}

export function ProjectDomainToJSON(json: any): ProjectDomain {
    return ProjectDomainToJSONTyped(json, false);
}

export function ProjectDomainToJSONTyped(value?: ProjectDomain | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'project': value['project'],
        'hostName': value['hostName'],
        'faviconUrl': value['faviconUrl'],
        'isBuiltin': value['isBuiltin'],
        'isEnabled': value['isEnabled'],
    };
}

